import { StaticFooterDataDocument } from '../../graphql/graphql';

export const getStaticFooterData = StaticFooterDataDocument;
